import { useEffect, useState } from 'react';

const createFontsHash = () => Math.ceil(Math.random() * 100000);

export function useClientFonts(clientName?: string) {
    const [fontsHash, setFontsHash] = useState(createFontsHash);

    const reloadFonts = () => setFontsHash(createFontsHash());

    useEffect(() => {
        if (!clientName) return;

        const stylesheet = document.createElement('link');
        stylesheet.id = 'fontes_edicao_pecas';
        stylesheet.rel = 'stylesheet';
        stylesheet.href = `/proxy/v2/fonts/${encodeURIComponent(clientName)}/fonts.css?hash=${fontsHash}`;
        document.head.appendChild(stylesheet);

        return () => stylesheet.remove();
    }, [clientName, fontsHash]);

    return { reloadFonts };
}
